import withValidations from '../../common/withValidations';
import styledFrame from './PatientCoverage.frame';

const validations = {};

export default withValidations(validations)(styledFrame);
